export const serverError = {
  title: 'Erro interno do sistema',
  description: 'Ocorreu uma instabilidade temporária que impediu a exibição do conteúdo, mas nossa equipe técnica já está trabalhando para resolver. Você pode tentar contornar o problema das seguintes formas:',
  steps: ['Recarregue a página pelo navegador.', 'Se o problema persistir, aguarde alguns minutos e acesse novamente o Painel do Wordpress.']
}
